

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
    // Mở popup_save khi click button
    const btnImage = document.querySelector('#ddtank-ld-25-twp-header .btn_image');
    if (btnImage) {
        btnImage.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Kiểm tra isLogin_
            const isLogin_ = (typeof window.isLogin_ !== 'undefined') ? window.isLogin_ : null;
            
            if (isLogin_ !== 1) {
                // Hiển thị popup login
                const popupLogin = document.querySelector('#popup_login');
                if (popupLogin) {
                    popupLogin.classList.add('active');
                }
                return;
            }
            
            const popupSave = document.querySelector('#popup_save');
            if (popupSave) {
                popupSave.classList.add('active');
            }
        });
    }
});
